import {
    createStyles,
    List,
    ListItem,
    ListItemText,
    makeStyles,
} from "@material-ui/core";
import { baseColors, CircleIcon, RelodeTheme, Text } from "@relode/core";
import * as React from "react";

import { MemberUpcomingInterview } from "../_infra/types";

const useStyles = makeStyles(
    (theme: RelodeTheme) =>
        createStyles({
            circle: {
                fontSize: "0.5em",
                margin: theme.spacing(1, 1, 0, 1),
                color: baseColors.light_blue,
            },
            interviewItem: {
                width: "unset",
                padding: theme.spacing(2, 2, 2, 2),
                margin: 0,
                borderBottom: `1px solid ${baseColors.border_gray}`,
            },
            interviewSection: {
                margin: theme.spacing(1, 0),
            },
            interviewDateSection: {
                margin: theme.spacing(1, 0),
                color: baseColors.gray,
            },
            interviewItemText: {
                padding: 0,
                margin: 0,
            },
            interviewList: {
                "& :last-child": {
                    border: "none",
                },
            },
        }),
    {
        name: "UpcomingInterviewsMobile",
    }
);

export const UpcomingInterviewsMobile = (props: {
    data: MemberUpcomingInterview[];
}) => {
    const classes = useStyles(props);
    const { data } = props;

    if (!data) return null;

    return (
        <List
            disablePadding
            id="upcomingMemberInterviewsListing"
            component="div"
            className={classes.interviewList}
        >
            {data.map((interview, index) => (
                <ListItem
                    key={index}
                    button
                    disableGutters
                    alignItems="flex-start"
                    component="a"
                    href={`candidates/${interview.jobId}/${interview.leadId}`}
                    className={classes.interviewItem}
                >
                    <ListItemText
                        className={classes.interviewItemText}
                        primary={interview.candidateName}
                        primaryTypographyProps={{
                            variant: "h5",
                            color: "primary",
                        }}
                        secondaryTypographyProps={{
                            component: "div",
                        }}
                        secondary={
                            <>
                                <Text
                                    component="div"
                                    className={classes.interviewDateSection}
                                >
                                    {interview.interviewDate},{" "}
                                    {interview.interviewTimeSpan}
                                </Text>
                                <div className={classes.interviewSection}>
                                    <Text component="span">
                                        {interview.jobName}
                                    </Text>
                                    <CircleIcon className={classes.circle} />
                                    <Text component="span">
                                        {interview.location}
                                    </Text>
                                </div>
                                <Text component="div">
                                    {interview.organization}
                                </Text>
                            </>
                        }
                    ></ListItemText>
                </ListItem>
            ))}
        </List>
    );
};
